module.exports = __webpack_public_path__ + "media/stylesheets/images/media/badge-619135c325beed1db9b0d87ccdd80b39.svg";